import { render, staticRenderFns } from "./AMRGB65R1_5.vue?vue&type=template&id=5a65a824&scoped=true"
import script from "./AMRGB65R1_5.vue?vue&type=script&lang=ts"
export * from "./AMRGB65R1_5.vue?vue&type=script&lang=ts"
import style0 from "./AMRGB65R1_5.vue?vue&type=style&index=0&id=5a65a824&prod&lang=scss&scoped=true"
import style1 from "./AMRGB65R1_5.vue?vue&type=style&index=1&id=5a65a824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65a824",
  null
  
)

export default component.exports